var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("配置投保模版")))])]), _c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      "label-col": {
        span: 3
      },
      "wrapper-col": {
        span: 13
      },
      rules: _vm.dataRule
    }
  }, [_c("a-form-model-item", {
    attrs: {
      prop: "batchTemplate",
      label: _vm.$t("批量投保模版")
    }
  }, [_c("a-upload", {
    attrs: {
      action: _vm.action,
      multiple: false,
      "file-list": _vm.fileList,
      headers: {
        "X-Dispatch": "Upload",
        "X-Version": "upload"
      },
      data: {
        module: "batchTemplate"
      },
      accept: "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    },
    on: {
      change: _vm.handleChange
    }
  }, [_c("a-button", [_vm._v(_vm._s(_vm.$t("上传文件")))])], 1)], 1), _vm._l(_vm.list, function (item, index) {
    return _c("div", {
      key: index
    }, [item.item.length != 0 ? _c("a-form-model-item", {
      attrs: {
        label: item.name
      }
    }, _vm._l(item.item, function (item2) {
      return _c("a-checkbox", {
        key: item2.id,
        model: {
          value: item2.selected,
          callback: function ($$v) {
            _vm.$set(item2, "selected", $$v);
          },
          expression: "item2.selected"
        }
      }, [_vm._v(_vm._s(item2.name))]);
    }), 1) : _vm._e()], 1);
  }), _c("a-form-model-item", {
    attrs: {
      "wrapper-col": {
        span: 14,
        offset: 3
      }
    }
  }, [_c("a-button", {
    attrs: {
      type: "add"
    },
    on: {
      click: _vm.addFun
    }
  }, [_vm._v(_vm._s(_vm.$t("添加")))])], 1)], 2), _c("div", {
    staticClass: "btnBox marginT20"
  }, [_c("a-button", {
    staticStyle: {
      "margin-right": "20px"
    },
    on: {
      click: function ($event) {
        return _vm.$emit("prev");
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("上一步")))]), _c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.processFun
    }
  }, [_vm._v("下一步")])], 1), _vm.templateShow ? _c("template-model", {
    ref: "templateFrom",
    on: {
      cancel: function ($event) {
        _vm.templateShow = false;
      },
      ok: _vm.infoFun
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };